module.exports = __webpack_public_path__ + "static/media/twitter.2c898e58.svg";